import injectSheet from 'react-jss';

import Patterns from './component';
import styles from './styles';

export default injectSheet(styles)(Patterns);
